import { format } from 'date-fns';
import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  ma_gd: z.string().optional(),
  ma_ngv: z.string().optional(),
  ma_kh: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_vt: z.string().optional(),
  ma_kho: z.string().optional(),
  ma_lo: z.string().optional(),
  ma_vi_tri: z.string().optional(),
  ma_unit: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  ma_kh: '',
  dien_giai: '',
  ma_ngv: 'ALL',
  ma_gd: 'ALL',
  ma_vt: '',
  ma_kho: '',
  ma_lo: '',
  ma_vi_tri: '',
  status: 'ALL',
  ma_unit: '',
  user_id0: 'ALL'
};

export const formSchema = z.object({
  // Basic information fields
  ma_gd: z.string().optional(),
  ma_ngv: z.string().optional(),
  ma_kh: z.string().optional(),
  dien_giai: z.string().optional(),
  so_ct: z.string().optional(),
  i_so_ct: z.coerce.number().optional(),
  ngay_ct: z.string().optional(),
  ngay_lct: z.string().optional(),
  status: z.string().optional(),
  transfer_yn: z.boolean().optional(),
  ma_nt: z.string().optional().nullable(),
  ty_gia: z.coerce.number().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_gd: '',
  ma_ngv: '5',
  ma_kh: '',
  dien_giai: '',
  so_ct: '',
  i_so_ct: 0,
  ngay_ct: format(new Date(), 'yyyy-MM-dd'),
  ngay_lct: format(new Date(), 'yyyy-MM-dd'),
  status: '5',
  transfer_yn: true,
  ma_nt: '',
  ty_gia: 1
};
